import {connect} from 'react-redux';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import Page from "../../app/components/Page";
import {withRouter} from "react-router-dom";
import Immutable from 'immutable';
import {
    DEMOTE_ADDRESSBOOK_USER,
    getAddressbooks,
    INVITE_ADDRESSBOOK,
    INVITE_ADDRESSBOOK_FAILURE,
    INVITE_ADDRESSBOOK_SUCCESS,
    LEAVE_ADDRESSBOOK,
    LEAVE_ADDRESSBOOK_FAILURE,
    LEAVE_ADDRESSBOOK_SUCCESS,
    PROMOTE_ADDRESSBOOK_USER,
    REMOVE_ADDRESSBOOK_USER
} from "../addressbooks";
import IsSpinning from "../../app/containers/IsSpinning";
import styles from "../../profile/containers/css/Addresses.scss";
import Icon from "../../../ui/Icon";
import ShareAddressbook from "../forms/ShareAddressbook";
import LeaveAddressbook from "../forms/LeaveAddressbook";
import {createSubmitAction} from "../../app/forms";
import Alert from "../../../ui/Alert";
import Button from "../../../ui/Button";
import Table from "../../../ui/Table";
import {isSpinning} from "../../app/spinner";
import {Helmet} from "react-helmet/es/Helmet";

@injectIntl
export class AddressbookManager extends Component {
  static propTypes = {
      intl: intlShape.isRequired,
  };

  constructor(props) {
      super(props);
      this.state = {
          invite_active: false,
          invite_success: false,

          promote_success: false,
          leave_success: false,
      }
  }

  componentDidMount() {
      this.props.dispatch(getAddressbooks());
  }

  handleInviteSuccess() {
      this.setState({ invite_success: true, invite_active: false });
  }

  render() {
      const { addressbooks } = this.props;
      const { formatMessage } = this.props.intl;

      const selectedAddressbookId = parseInt(this.props.match.params.addressbookId);
      const addressbook = addressbooks.get(selectedAddressbookId);

      if (!addressbook) {
          return (
              <IsSpinning id='addressbook'>
                  <div className={styles.loadingMessage}>
                      <Icon name='refresh' spin fixedWidth />{' '}
                      <FormattedMessage id='common.helper.please_wait' />
                  </div>
              </IsSpinning>
          );
      }

      return (
          <Page.Body>
              <Helmet title={formatMessage({ id: 'frontend.pagetitle.manage_addressbook' })} />
              <Page.Section depth={0}>
                  <h1>
                      <FormattedMessage id='frontend.addressbook.headline.manage' />: { addressbook.get('name') }
                  </h1>
              </Page.Section>

              {this.renderUserManagement(addressbook)}
              {this.renderLeaveButton(addressbook)}

              <br/>

              <Page.Section>
                  <Button block link to='./'>
                      <FormattedMessage id='common.helper.button.cancel' />
                  </Button>
              </Page.Section>
          </Page.Body>
      );
  }

  renderLeaveButton(addressbook) {
      if (addressbook.get('ownerId') === this.props.session.getIn(['user', 'id'])) {
          return null;
      }

      if (this.state.leave_success) {
      // Forces site to reload all location information
          const currentPath = window.location.pathname;
          window.location.href = currentPath.substring(0, currentPath.lastIndexOf("/"));
      }

      return (
          <div>
              <Page.Section depth={0}>
                  <h2>
                      <FormattedMessage id='frontend.addressbook.headline.leave' />
                  </h2>
              </Page.Section>
              <Page.Section>
                  <Page.Content>
                      <LeaveAddressbook.Component
                          initialValues={{addressbook: addressbook.get('id')}}
                          onSubmitSuccess={() => this.setState({leave_success: true})}
                          onSubmit={createSubmitAction(
                              LEAVE_ADDRESSBOOK,
                              LEAVE_ADDRESSBOOK_SUCCESS,
                              LEAVE_ADDRESSBOOK_FAILURE
                          )} />
                  </Page.Content>
              </Page.Section>
          </div>
      );
  }

  renderUserManagement(addressbook) {
      if (!addressbook.get('isManager')) {
          return null;
      }

      return (
          <div>
              <Page.Section depth={0}>
                  <h2>
                      <FormattedMessage id='frontend.addressbook.headline.invite' />
                  </h2>
              </Page.Section>
              <Page.Section>
                  <Page.Content>
                      {this.state.invite_success ? (<div><Alert><FormattedMessage id='frontend.addressbook.text.user_added' /></Alert><br/></div>) : null}
                      {this.state.invite_active ? (
                          <div>
                              <ShareAddressbook.Component
                                  initialValues={{addressbook: addressbook.get('id')}}
                                  onSubmitSuccess={() => this.handleInviteSuccess()}
                                  onSubmit={createSubmitAction(
                                      INVITE_ADDRESSBOOK,
                                      INVITE_ADDRESSBOOK_SUCCESS,
                                      INVITE_ADDRESSBOOK_FAILURE
                                  )} />
                              <br/>
                              <Button block onClick={() => this.setState({invite_active: false, invite_success: false})}><FormattedMessage id='common.helper.button.cancel' /></Button>
                          </div>
                      ) : (
                          <Button onClick={() => this.setState({invite_active: true, invite_success: false})}><FormattedMessage id='addressbook.button.add_user' /></Button>
                      )}
                  </Page.Content>
              </Page.Section>

              <Page.Section depth={0}>
                  <h2>
                      <FormattedMessage id='frontend.addressbook.headline.users' />
                  </h2>
              </Page.Section>
              <Page.Section>
                  <Table>
                      <Table.Row type='header' className={styles.headerRow}>
                          <Table.Cell className={styles.headerCell}><FormattedMessage id='frontend.addressbook.label.name' /></Table.Cell>
                          <Table.Cell className={styles.headerCell}><FormattedMessage id='frontend.addressbook.label.email' /></Table.Cell>
                          <Table.Cell className={styles.headerCell}><FormattedMessage id='frontend.addressbook.label.role' /></Table.Cell>
                          <Table.Cell className={styles.headerCell}/>
                      </Table.Row>
                      { this.renderMemberRow(addressbook, addressbook.get('owner')) }
                      { addressbook.has('members') && addressbook.get('members').map((member) => this.renderMemberRow(addressbook, member)) }
                  </Table>
              </Page.Section>
          </div>
      );
  }

  renderMemberRow(addressbook, member) {
      let isRoleChangeable = true;
      let role = member.get('isManager') ? 'manager' : 'user';

      if (member.get('isOwner') || addressbook.get('ownerId') === member.get('id')) {
          isRoleChangeable = false;
          role = 'owner';
      } else if (member.get('email') === this.props.session.get('user').get('email')) {
          isRoleChangeable = false;
          if (addressbook.get('isManager')) {
              role = 'manager';
          }
      }

      return (
          <Table.Row type='body' className={styles.row}>
              <Table.Cell className={styles.cell}>{ member.get('name') }</Table.Cell>
              <Table.Cell className={styles.cell}>{ member.get('email') }</Table.Cell>
              <Table.Cell className={styles.cell}><FormattedMessage id={'frontend.addressbook.role.' + role} /></Table.Cell>
              <Table.Cell className={styles.cell} style={{textAlign: 'right'}}>
                  {
                      isRoleChangeable
                          ? this.renderButtons(member.get('isManager') ? 'demote' : 'promote', addressbook.get('id'), member.get('id'))
                          : <FormattedMessage id='frontend.addressbook.text.role_locked' />
                  }
              </Table.Cell>
          </Table.Row>
      );
  }

  renderButtons(type, addressbookId, userId) {
      const { spinners } = this.props;

      const isChanging = isSpinning(spinners, 'addressbook_' + type + '_' + userId);
      const isRemoving = isSpinning(spinners, 'addressbook_remove_' + userId);

      return (
          <div>
              <Button emphasis='primary' disabled={isRemoving || isChanging} onClick={() => this.props.dispatch({
                  type: type === 'promote' ? PROMOTE_ADDRESSBOOK_USER : DEMOTE_ADDRESSBOOK_USER,
                  payload: Immutable.Map({ addressbook: addressbookId, user: userId })
              })}><FormattedMessage id={'addressbook.button.' + type} /></Button>

              <Button emphasis='deactivate' disabled={isRemoving || isChanging} onClick={() => this.props.dispatch({
                  type: REMOVE_ADDRESSBOOK_USER,
                  payload: Immutable.Map({ addressbook: addressbookId, user: userId })
              })} style={{padding: '0.25em 0.75em'}}><Icon name='sign-out' fixedWidth /></Button>
          </div>
      );
  }
}

export default withRouter(connect(state => ({
    addressbooks: state.addressbooks,
    session: state.session,
    spinners: state.spinner,
}))(AddressbookManager));
